import { Link } from "react-router-dom";
import { useRadarTrackingStatus, useTrackCompanyInRadar } from "@/features/radar/hooks";

export function RadarTracker({
  organizationId,
  companyName,
}: {
  organizationId: string | null;
  companyName: string;
}): JSX.Element {
  const status = useRadarTrackingStatus(organizationId, companyName);
  const track = useTrackCompanyInRadar(organizationId, companyName);
  const active = status.data?.status === "active" || track.data?.status === "active";

  return (
    <section className="sxco-section">
      <div className="sxco-scan sxco-radar-tracker">
        <div className="sxco-scan-head">
          <span className="sxco-eyebrow">MAKE THIS A RADAR SIGNAL</span>
          {active ? (
            <span className="sxco-scan-chip sxco-scan-chip--terminal">Tracking</span>
          ) : null}
        </div>
        <p className="sxco-scan-copy">
          Track this company and receive signals in the Tracking tab in RADAR.
        </p>
        {!organizationId ? (
          <p className="sxco-scan-meta">
            BDSE needs to confirm this company’s official profile and aliases. Once verified, RADAR
            will track it and notify you when new signals are found.
          </p>
        ) : null}
        {status.isError || track.isError ? (
          <p className="sxco-scan-error">
            {(track.error ?? status.error)?.message ?? "RADAR tracking could not be updated."}
          </p>
        ) : null}
        {active ? (
          <Link className="sx-btn sx-btn-hero sxco-scan-cta" to="/radar?view=tracking">
            View in RADAR
          </Link>
        ) : (
          <button
            type="button"
            className="sx-btn sx-btn-hero sxco-scan-cta"
            onClick={() => track.mutate()}
            disabled={track.isPending || status.isPending}
          >
            <span className="sxco-radar-pulse" aria-hidden="true" />
            {track.isPending ? "Adding tracker…" : "RADAR Tracker"}
          </button>
        )}
      </div>
    </section>
  );
}
